import { Routes, RouterModule }  from '@angular/router';

import { FOCRequestConfirmComponent} from './foc-confirm/foc-confirm.component';
import { FOCRequestAddComponent } from './foc-create/foc-request_add.component';
import { FOCRequestReturnComponent } from './foc-return/foc-return.component';
import { FOCRequestsComponent} from './foc-requests.component';

export const FOCRequestsRoutes: Routes = [
    {
        path: '',
        component: FOCRequestsComponent,
        children: [
            { path: '', redirectTo: '/app/focdashboard', pathMatch: 'full' },
            { path: 'create', component: FOCRequestAddComponent },
            { path: 'return', component: FOCRequestReturnComponent },
            { path: 'confirm', component: FOCRequestConfirmComponent },
            { path: 'create/:id', component: FOCRequestAddComponent },
            { path: 'return/:id', component: FOCRequestReturnComponent },
            { path: 'confirm/:id', component: FOCRequestConfirmComponent }
        ]
    }
];

export const FOCRequestsRoutingModule = RouterModule.forChild(FOCRequestsRoutes);



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/request-mgmt-foc/foc-requests-routing.module.ts